import Network from '../../helpers/networking/network';

const type = 'user';
const api = Network();

const path = resource => {
  if (!resource) resource = '';
  return { resource: 'api/users/' + resource };
}

// send request to API to verify contact type (email/phone) and send login token
export const verify = (type, contact) => {
  return (dispatch, getState) => {
    return api.post(path('verify'), {
      type: type,
      contact: contact
    })
  }
}

export const verifyToken = (type, contact, token) => {
  return (dispatch, getState) => {
    return api.post(path('verified'), {
      type: type,
      contact: contact,
      verification_code: token
    });
  }
}
